import { Radio } from 'antd';
import './customRadioButton.scss'

const CustomRadioButton = ({text,value,width,isChecked,disabled})=>{

    return (
        <div className={'custom-radio-wrapper'} style={{width:`${width}px`,borderColor:`${isChecked ? '#32B8C5':'#ccc'}`}}>
            <Radio checked={isChecked} value={value} disabled={disabled}>{text}</Radio>
        </div>
    )
}

export default CustomRadioButton